import AppDataService from "./AppDataService";

const COMMON_BASE = 'History'

export default class HistoryDataService {
    static async GetPrepayHistoryData(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetPrepayHistoryData`, { params });
    }
    static async GetAdminAndMemberPrepay() {
        return await AppDataService.get(`${COMMON_BASE}/GetAdminandMemberPrepay`);
    }
    static async GetPrepayExport() {
        return await AppDataService.get(`${COMMON_BASE}/GetPrepayExport`);
    }
    static async ProcessRefundRequest() {
        return await AppDataService.get(`${COMMON_BASE}/ProcessRefundRequest`);
    }
    static async GetW8W9RequestsHistoryDetails(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetW8W9RequestsHistoryDetails`, { params });
    }
    static async UpdateMemberUserAccess(data) {
        return await AppDataService.put(`${COMMON_BASE}/UpdateMemberUserAccess?adminPrepaidAccess=${data}`);
    }
    static async GetFilingHistoryData(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetFilingHistoryData`, { params } );
    }
    static async GetStateSubmissionDetails(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetStateSubmissionDetails`, { params } );
    }
    static async getFilingStatuses() {
        return await AppDataService.get(`${COMMON_BASE}/GetFilingStatuses` );
    }
    static async get94XFormList() {
        return await AppDataService.get(`${COMMON_BASE}/Get94XFormList` );
    }
    static async getCascadePayers() {
        return await AppDataService.get(`${COMMON_BASE}/GetCascadePayers`);
    }
    static async getMemberUserHistoryDetails(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetMemberUserHistoryDetails`, { params });
    }
    static async exportToExcel (){
        return await AppDataService.get(`${COMMON_BASE}/ExportToExcel`)
    }
    static async checkW8W9Payment (params){
        return await AppDataService.get(`${COMMON_BASE}/CheckW8W9Payment`, {params})
    }
    static async getW8W9Plans (){
        return await AppDataService.get(`${COMMON_BASE}/GetW8W9Plans`)
    }
    static async getStatePayrollStateNames() {
        return await AppDataService.get(`${COMMON_BASE}/GetStatePayrollStates`);
    }
    static async getStatePayrollFormNames(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetStatePayrollFormNames?stateName=${params}`)
    }
    static async getStatePayrollPayerNames(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetStatePayrollPayers?statePayrollFormId=${params}`)
    }
    static async getStatePayrollHistoryData({ PageSize, PageNumber, taxYear, formId, payerId }) {
        return await AppDataService.get(`${COMMON_BASE}/GetStatePayrollHistoryData?PageSize=${PageSize}&PageNumber=${PageNumber}&taxYear=${taxYear}&formId=${formId}&payerId=${payerId}`)
    }

}